import React from "react";
import HomeScreen from "../components/Home/HomeScreen";
import HomeNav from "../components/Home/HomeNav";

const Home = () => {
  return (
    <>
      <HomeNav />
      <HomeScreen />
    </>
  );
};

export default Home;
